export default __webpack_public_path__ + "static/media/img_we_can.ec0142ad.svg";